import React, { useState } from 'react';
import heroImage from '../assets/hero.webp';
import heroImage1 from '../assets/hero1.webp';
import about1 from '../assets/about1.webp';


const GovernmentSchemes = () => {
  const [activeFaq, setActiveFaq] = useState(null);

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  return (
    <div className="bg-gray-50 min-h-screen" style={{ marginTop: '80px' }}>
      {/* Hero Section */}
      <div className="relative h-96 overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src={heroImage} 
            alt="Farmers working in field"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black opacity-50"></div>
        </div>
        <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 animate-fade-in">
            किसानों के लिए सरकारी योजनाएं
          </h1>
          <p className="text-xl md:text-2xl text-white max-w-2xl mx-auto">
            आपके खेतों की तरक्की के लिए सरकार की खास मदद | सीधा लाभ, आसान आवेदन
          </p>
          <div className="mt-6 flex gap-4">
            <a 
              href="#yojana-list" 
              className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-medium transition duration-300"
            >
              योजनाएं देखें
            </a>
            <a 
              href="#apply-now" 
              className="bg-white hover:bg-gray-100 text-green-700 px-6 py-3 rounded-lg font-medium transition duration-300"
            >
              अभी आवेदन करें
            </a>
          </div>
        </div>
      </div>

      {/* Breadcrumb Navigation */}
      <div className="bg-gray-100 py-3 px-4">
        <div className="container mx-auto">
          <nav className="flex" aria-label="Breadcrumb">
            <ol className="inline-flex items-center space-x-1 md:space-x-3">
              <li className="inline-flex items-center">
                <a href="/" className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-green-600">
                  <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path></svg>
                  होम
                </a>
              </li>
              <li>
                <div className="flex items-center">
                  <svg className="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"></path></svg>
                  <span className="ml-1 text-sm font-medium text-gray-500 md:ml-2">सरकारी योजनाएं</span>
                </div>
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-8">
        {/* Introduction Section */}
        <section className="mb-12 bg-white rounded-xl shadow-md p-6">
          <h2 className="text-3xl font-bold mb-6 text-center text-gray-800">
            किसान भाइयों के लिए सरकार की विशेष सहायता
          </h2>
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <p className="text-lg text-gray-700 mb-4">
                भारत सरकार ने किसानों की आमदनी बढ़ाने और खेती को आसान बनाने के लिए कई योजनाएं शुरू की हैं। इन योजनाओं से आपको पैसों की मदद, बीमा सुरक्षा और आधुनिक खेती के साधन मिल सकते हैं।
              </p>
              <p className="text-lg text-gray-700 mb-4">
                हमारे इस पेज पर आपको हर योजना की पूरी जानकारी सरल हिंदी में मिलेगी - क्या फायदा है, कौन ले सकता है, कैसे आवेदन करें और कौन से कागजात चाहिए।
              </p>
              <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500">
                <p className="font-semibold">महत्वपूर्ण सूचना:</p>
                <p>अधिकांश योजनाओं के लिए आधार कार्ड और बैंक खाता जरूरी है। कृपया इन्हें पहले से तैयार रखें।</p>
              </div>
             
             <audio controls className="mb-6">
                      <source src="/audio/sarkariyojnaye.mp3" type="audio/mp3" />

                   आपका ब्राउज़र ऑडियो को सपोर्ट नहीं करता।
                   </audio> 
            </div>
            <div className="bg-gray-100 rounded-lg overflow-hidden">
              <img 
                src={about1} 
                alt="किसान सरकारी योजना का लाभ लेते हुए"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </section>

        {/* Schemes List */}
        <section id="yojana-list" className="mb-12">
          <h2 className="text-3xl font-bold mb-8 text-center bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
            प्रमुख किसान योजनाएं
          </h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            {/* PM KISAN */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden transform transition duration-300 hover:shadow-lg hover:-translate-y-1">
              <div className="bg-green-600 p-4 text-white">
                <h3 className="text-2xl font-bold">PM किसान सम्मान निधि</h3>
                <p>हर साल 6000 रुपये सीधे बैंक खाते में</p>
              </div>
              <div className="p-6">
                <div className="flex items-start mb-4">
                  <div className="bg-green-100 p-2 rounded-full mr-3 mt-1">
                    <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg">क्या मिलेगा?</h4>
                    <p className="text-gray-600">हर साल 6000 रुपये (2000 रुपये की 3 किश्तों में) सीधे आपके बैंक खाते में</p>
                  </div>
                </div>
                
                <div className="flex items-start mb-4">
                  <div className="bg-green-100 p-2 rounded-full mr-3 mt-1">
                    <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg">कौन ले सकता है?</h4>
                    <p className="text-gray-600">जिन किसानों के पास अपनी खेती की जमीन है (2 हेक्टेयर तक)। सरकारी नौकरी करने वाले और आयकर भरने वाले किसान इसके लिए पात्र नहीं हैं।</p>
                  </div>
                </div>
                
                <div className="flex items-start mb-4">
                  <div className="bg-green-100 p-2 rounded-full mr-3 mt-1">
                    <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg">कैसे आवेदन करें?</h4>
                    <ol className="list-decimal pl-5 text-gray-600 space-y-1">
                      <li>PM-KISAN की वेबसाइट (pmkisan.gov.in) पर जाएं</li>
                      <li>'New Farmer Registration' पर क्लिक करें</li>
                      <li>अपना आधार नंबर, मोबाइल नंबर और जमीन का विवरण भरें</li>
                      <li>जरूरी कागजात अपलोड करें</li>
                      <li>फॉर्म जमा करें और पावती नंबर नोट कर लें</li>
                    </ol>
                  </div>
      
                </div>
                
                <div className="bg-yellow-50 p-4 rounded-lg border-l-4 border-yellow-400 mt-4">
                  <p className="font-semibold text-yellow-800">ध्यान दें:</p>
                  <p className="text-yellow-700">आधार कार्ड को बैंक खाते से जोड़ना जरूरी है। एक परिवार में सिर्फ एक व्यक्ति ही योजना का लाभ ले सकता है।</p>
                </div>
                
                <a 
                  href="https://pmkisan.gov.in" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="mt-4 inline-flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition duration-300"
                >
                  अभी आवेदन करें
                  <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </a>
              </div>
            </div>

            {/* Kisan Credit Card */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden transform transition duration-300 hover:shadow-lg hover:-translate-y-1">
              <div className="bg-blue-600 p-4 text-white">
                <h3 className="text-2xl font-bold">किसान क्रेडिट कार्ड (KCC)</h3>
                <p>कम ब्याज दर पर फसल ऋण की सुविधा</p>
              </div>
              <div className="p-6">
                <div className="flex items-start mb-4">
                  <div className="bg-blue-100 p-2 rounded-full mr-3 mt-1">
                    <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg">क्या मिलेगा?</h4>
                    <p className="text-gray-600">सालाना सिर्फ 4% ब्याज पर 3 लाख रुपये तक का कर्ज। आपात स्थिति में अतिरिक्त 50,000 रुपये तक का ऋण।</p>
                  </div>
                </div>
                
                <div className="flex items-start mb-4">
                  <div className="bg-blue-100 p-2 rounded-full mr-3 mt-1">
                    <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg">कौन ले सकता है?</h4>
                    <p className="text-gray-600">सभी किसान - चाहे उनके पास थोड़ी जमीन हो या ज्यादा। बटाईदार (किराए पर खेती करने वाले) और पशुपालक भी आवेदन कर सकते हैं।</p>
                  </div>
                </div>
                
                <div className="flex items-start mb-4">
                  <div className="bg-blue-100 p-2 rounded-full mr-3 mt-1">
                    <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg">कैसे आवेदन करें?</h4>
                    <ol className="list-decimal pl-5 text-gray-600 space-y-1">
                      <li>अपने नजदीकी सहकारी बैंक, SBI या किसी अन्य सरकारी बैंक में जाएं</li>
                      <li>KCC के लिए आवेदन फॉर्म लें और भरें</li>
                      <li>जरूरी कागजात जमा करें (आधार, जमीन के कागजात, फोटो)</li>
                      <li>बैंक अधिकारी आपके खेत का निरीक्षण करेगा</li>
                      <li>सब कुछ ठीक होने पर 2-3 हफ्ते में कार्ड मिल जाएगा</li>
                    </ol>
                  </div>
                </div>
                
                <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-400 mt-4">
                  <p className="font-semibold text-blue-800">विशेष लाभ:</p>
                  <p className="text-blue-700">KCC धारकों को फसल बीमा में छूट मिलती है और सरकारी सब्सिडी वाली योजनाओं में प्राथमिकता दी जाती है।</p>
                </div>
                
                <a 
                  href="https://pmkisan.gov.in/homenew.aspx" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="mt-4 inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition duration-300"
                >
                  अधिक जानकारी
                  <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </a>
              </div>
            </div>

            {/* PM Fasal Bima Yojana */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden transform transition duration-300 hover:shadow-lg hover:-translate-y-1">
              <div className="bg-purple-600 p-4 text-white">
                <h3 className="text-2xl font-bold">प्रधानमंत्री फसल बीमा योजना</h3>
                <p>फसल खराब होने पर मुआवजा</p>
              </div>
              <div className="p-6">
                <div className="flex items-start mb-4">
                  <div className="bg-purple-100 p-2 rounded-full mr-3 mt-1">
                    <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg">क्या मिलेगा?</h4>
                    <p className="text-gray-600">बाढ़, सूखा, ओलावृष्टि या कीटों से फसल खराब होने पर पूरी लागत का मुआवजा। 2 हेक्टेयर तक के लिए सरकार प्रीमियम का अधिकांश भाग देती है।</p>
                  </div>
                </div>
                
                <div className="flex items-start mb-4">
                  <div className="bg-purple-100 p-2 rounded-full mr-3 mt-1">
                    <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg">कौन ले सकता है?</h4>
                    <p className="text-gray-600">सभी किसान जो योजना में शामिल फसलें उगाते हैं। KCC लेने वाले किसानों के लिए यह बीमा अनिवार्य है।</p>
                  </div>
                </div>
                
                <div className="flex items-start mb-4">
                  <div className="bg-purple-100 p-2 rounded-full mr-3 mt-1">
                    <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg">कैसे आवेदन करें?</h4>
                    <ol className="list-decimal pl-5 text-gray-600 space-y-1">
                      <li>बीमा कंपनी (Pradhan Mantri Fasal Bima Yojana) के एजेंट से संपर्क करें</li>
                      <li>फसल बोने के 10-15 दिनों के भीतर आवेदन करें</li>
                      <li>आधार कार्ड, जमीन के कागजात और बैंक विवरण दें</li>
                      <li>प्रीमियम राशि का भुगतान करें (बहुत कम राशि)</li>
                      <li>बीमा पॉलिसी और प्रमाणपत्र प्राप्त करें</li>
                    </ol>
                  </div>
                </div>
                
                <div className="bg-purple-50 p-4 rounded-lg border-l-4 border-purple-400 mt-4">
                  <p className="font-semibold text-purple-800">प्रीमियम दरें:</p>
                  <p className="text-purple-700">खरीफ फसलों के लिए 2%, रबी फसलों के लिए 1.5% और फल/सब्जियों के लिए 5%। बाकी राशि सरकार भरती है।</p>
                </div>
                
                <a 
                  href="https://pmfby.gov.in" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="mt-4 inline-flex items-center px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition duration-300"
                >
                  ऑनलाइन आवेदन
                  <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </a>
              </div>
            </div>

            {/* Soil Health Card */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden transform transition duration-300 hover:shadow-lg hover:-translate-y-1">
              <div className="bg-red-600 p-4 text-white">
                <h3 className="text-2xl font-bold">मृदा स्वास्थ्य कार्ड योजना</h3>
                <p>मिट्टी की जांच और सही खाद की सलाह</p>
              </div>
              <div className="p-6">
                <div className="flex items-start mb-4">
                  <div className="bg-red-100 p-2 rounded-full mr-3 mt-1">
                    <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg">क्या मिलेगा?</h4>
                    <p className="text-gray-600">आपके खेत की मिट्टी की पूरी जांच रिपोर्ट और कौन सी खाद/उर्वरक कितनी मात्रा में डालें, इसकी सलाह।</p>
                  </div>
                </div>
                
                <div className="flex items-start mb-4">
                  <div className="bg-red-100 p-2 rounded-full mr-3 mt-1">
                    <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg">कौन ले सकता है?</h4>
                    <p className="text-gray-600">देश का कोई भी किसान। हर 3 साल में एक बार मुफ्त मिट्टी जांच की सुविधा।</p>
                  </div>
                </div>
                
                <div className="flex items-start mb-4">
                  <div className="bg-red-100 p-2 rounded-full mr-3 mt-1">
                    <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg">कैसे आवेदन करें?</h4>
                    <ol className="list-decimal pl-5 text-gray-600 space-y-1">
                      <li>नजदीकी कृषि विभाग के कार्यालय या कृषि विज्ञान केंद्र पर जाएं</li>
                      <li>मिट्टी जांच के लिए आवेदन फॉर्म भरें</li>
                      <li>अधिकारी आपके खेत से मिट्टी के नमूने लेंगे</li>
                      <li>2-3 हफ्ते में मिट्टी की रिपोर्ट और सलाह कार्ड मिल जाएगा</li>
                      <li>इस कार्ड के आधार पर खाद और उर्वरक का प्रयोग करें</li>
                    </ol>
                  </div>
                </div>
                
                <div className="bg-red-50 p-4 rounded-lg border-l-4 border-red-400 mt-4">
                  <p className="font-semibold text-red-800">फायदे:</p>
                  <p className="text-red-700">मिट्टी की जांच से आप सही मात्रा में सही खाद डालेंगे, जिससे लागत कम होगी और उपज 15-20% तक बढ़ सकती है।</p>
                </div>
                
                <a 
                  href="https://soilhealth.dac.gov.in" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="mt-4 inline-flex items-center px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition duration-300"
                >
                  ऑनलाइन ट्रैक करें
                  <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Documents Section */}
        <section className="mb-12 bg-white rounded-xl shadow-md p-6">
          <h2 className="text-3xl font-bold mb-6 text-center bg-gradient-to-r from-orange-500 to-pink-500 bg-clip-text text-transparent">
            जरूरी दस्तावेज और कागजात
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-xl font-semibold mb-4 text-gray-800 border-b pb-2">सभी योजनाओं के लिए सामान्य दस्तावेज</h3>
              <ul className="space-y-3">
                <li className="flex items-start bg-gray-50 p-3 rounded-lg">
                  <div className="bg-green-100 p-1 rounded-full mr-3 mt-1">
                    <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-medium">आधार कार्ड</h4>
                    <p className="text-sm text-gray-600">मूल और फोटोकॉपी (आधार नंबर सभी योजनाओं के लिए अनिवार्य है)</p>
                  </div>
                </li>
                <li className="flex items-start bg-gray-50 p-3 rounded-lg">
                  <div className="bg-green-100 p-1 rounded-full mr-3 mt-1">
                    <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-medium">भूमि के कागजात</h4>
                    <p className="text-sm text-gray-600">7/12 उतरा, खतौनी या भूमि पट्टे की कॉपी (नाम मिलना चाहिए)</p>
                  </div>
                </li>
                <li className="flex items-start bg-gray-50 p-3 rounded-lg">
                  <div className="bg-green-100 p-1 rounded-full mr-3 mt-1">
                    <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-medium">बैंक खाता विवरण</h4>
                    <p className="text-sm text-gray-600">पासबुक की फोटोकॉपी या चेक (IFSC कोड सहित)</p>
                  </div>
                </li>
                <li className="flex items-start bg-gray-50 p-3 rounded-lg">
                  <div className="bg-green-100 p-1 rounded-full mr-3 mt-1">
                    <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-medium">फोटो</h4>
                    <p className="text-sm text-gray-600">पासपोर्ट साइज की 2-4 तस्वीरें (हाल के 6 महीने की)</p>
                  </div>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-4 text-gray-800 border-b pb-2">विशेष योजनाओं के लिए अतिरिक्त दस्तावेज</h3>
              <ul className="space-y-3">
                <li className="flex items-start bg-gray-50 p-3 rounded-lg">
                  <div className="bg-blue-100 p-1 rounded-full mr-3 mt-1">
                    <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-medium">KCC के लिए</h4>
                    <p className="text-sm text-gray-600">आय प्रमाण पत्र, पहचान प्रमाण (वोटर ID/ड्राइविंग लाइसेंस), ऋण आवेदन फॉर्म</p>
                  </div>
                </li>
                <li className="flex items-start bg-gray-50 p-3 rounded-lg">
                  <div className="bg-blue-100 p-1 rounded-full mr-3 mt-1">
                    <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-medium">फसल बीमा के लिए</h4>
                    <p className="text-sm text-gray-600">बीज खरीद रसीद, फसल बुवाई प्रमाण पत्र, KCC (अगर है तो)</p>
                  </div>
                </li>
                <li className="flex items-start bg-gray-50 p-3 rounded-lg">
                  <div className="bg-blue-100 p-1 rounded-full mr-3 mt-1">
                    <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-medium">सब्सिडी योजनाओं के लिए</h4>
                    <p className="text-sm text-gray-600">पिछले वर्ष की उपज रिकॉर्ड, कृषि उपकरण खरीद रसीद (अगर लागू हो)</p>
                  </div>
                </li>
                <li className="flex items-start bg-gray-50 p-3 rounded-lg">
                  <div className="bg-blue-100 p-1 rounded-full mr-3 mt-1">
                    <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-medium">सिंचाई योजनाओं के लिए</h4>
                    <p className="text-sm text-gray-600">जल संसाधन विभाग का NOC, भूजल प्रमाण पत्र (अगर लागू हो)</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-6 bg-yellow-50 p-4 rounded-lg border-l-4 border-yellow-400">
            <p className="font-semibold text-yellow-800">नोट:</p>
            <p className="text-yellow-700">सभी दस्तावेजों की सेल्फ अटेस्टेड कॉपी (खुद द्वारा सत्यापित) जमा करें। मूल दस्तावेज सत्यापन के लिए साथ ले जाएं।</p>
          </div>
        </section>

        {/* E-Services Section */}
        <section id="apply-now" className="mb-12 bg-white rounded-xl shadow-md p-6">
          <h2 className="text-3xl font-bold mb-6 text-center bg-gradient-to-r from-indigo-500 to-purple-600 bg-clip-text text-transparent">
            ऑनलाइन सेवाएं और आवेदन
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="border border-gray-200 rounded-lg hover:shadow-md transition duration-300">
              <div className="bg-indigo-600 p-4 text-white rounded-t-lg">
                <h3 className="text-xl font-semibold">PM-KISAN पोर्टल</h3>
              </div>
              <div className="p-4">
                <p className="text-gray-600 mb-4">आवेदन, स्थिति जांच और लाभार्थी सूची देखने के लिए आधिकारिक पोर्टल</p>
                <div className="space-y-2">
                  <a href="https://pmkisan.gov.in" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-indigo-600 hover:text-indigo-800 font-medium">
                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                    </svg>
                    आधिकारिक वेबसाइट
                  </a>
                  <a href="https://pmkisan.gov.in/FarmerCorner.aspx" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-indigo-600 hover:text-indigo-800 font-medium">
                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h11a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                    </svg>
                    ऑनलाइन आवेदन
                  </a>
                  <a href="https://pmkisan.gov.in/BeneficiaryStatus.aspx" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-indigo-600 hover:text-indigo-800 font-medium">
                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                    </svg>
                    स्थिति जांचें
                  </a>
                </div>
              </div>
            </div>

            <div className="border border-gray-200 rounded-lg hover:shadow-md transition duration-300">
              <div className="bg-green-600 p-4 text-white rounded-t-lg">
                <h3 className="text-xl font-semibold">फसल बीमा पोर्टल</h3>
              </div>
              <div className="p-4">
                <p className="text-gray-600 mb-4">फसल बीमा आवेदन, प्रीमियम भुगतान और दावा स्थिति</p>
                <div className="space-y-2">
                  <a href="https://pmfby.gov.in" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-green-600 hover:text-green-800 font-medium">
                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                    </svg>
                    आधिकारिक वेबसाइट
                  </a>
                  <a href="https://pmfby.gov.in/statePortal" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-green-600 hover:text-green-800 font-medium">
                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h11a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                    </svg>
                    राज्यवार आवेदन
                  </a>
                  <a href="https://pmfby.gov.in/claimStatus" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-green-600 hover:text-green-800 font-medium">
                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                    </svg>
                    दावा स्थिति
                  </a>
                </div>
              </div>
            </div>

            <div className="border border-gray-200 rounded-lg hover:shadow-md transition duration-300">
              <div className="bg-yellow-500 p-4 text-white rounded-t-lg">
                <h3 className="text-xl font-semibold">किसान सुविधा ऐप</h3>
              </div>
              <div className="p-4">
                <p className="text-gray-600 mb-4">मोबाइल ऐप के माध्यम से सभी योजनाओं की जानकारी और आवेदन</p>
                <div className="space-y-3">
                  
                  <a href="https://www.manage.gov.in/fpoacademy/portalsapps.asp" className="flex items-center justify-between bg-green-600 text-white px-3 py-2 rounded-lg">
                    <div className="flex items-center">
                      <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 20.5v-17c0-.59.34-1.11.84-1.35L13.69 12l-9.85 9.85c-.5-.25-.84-.76-.84-1.35m13.81-15.38L6.05 21.34l7.36-7.36 3.4-3.4 7.36-7.36-6.23 6.23m-.83-.83l6.23-6.23c.59-.59.59-1.54 0-2.12L19.8.65c-.59-.58-1.54-.58-2.12 0l-6.23 6.23 3.4 3.4z" />
                      </svg>
                      <span>Play Store</span>
                    </div>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </a>
                  <a href="#" className="inline-flex items-center text-yellow-600 hover:text-yellow-800 font-medium">
                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                    मिस्ड कॉल: 9013151515
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="mb-12 bg-white rounded-xl shadow-md p-6">
          <h2 className="text-3xl font-bold mb-6 text-center bg-gradient-to-r from-teal-500 to-blue-500 bg-clip-text text-transparent">
            अक्सर पूछे जाने वाले प्रश्न (FAQ)
          </h2>
          <div className="space-y-4">
            {[
              {
                question: "PM-KISAN योजना में आवेदन करने के बाद भुगतान क्यों नहीं मिला?",
                answer: "इसके कई कारण हो सकते हैं:\n\n1. आपका आधार कार्ड बैंक खाते से लिंक नहीं है\n2. भूमि रिकॉर्ड में आपका नाम नहीं है या नाम में अंतर है\n3. आप आयकर भरते हैं या सरकारी नौकरी करते हैं\n4. बैंक खाता सक्रिय नहीं है या IFSC कोड गलत है\n\nसमाधान: अपने जिले के कृषि अधिकारी से संपर्क करें या हेल्पलाइन नंबर 1800-180-1551 पर कॉल करें।"
              },
              {
                question: "KCC के लिए कितनी जमीन होना जरूरी है?",
                answer: "KCC के लिए न्यूनतम जमीन की कोई सीमा नहीं है। छोटे और सीमांत किसान भी आवेदन कर सकते हैं। ऋण राशि जमीन के आकार और फसल पैटर्न पर निर्भर करती है।\n\nबिना जमीन वाले किसान (बटाईदार/किराए पर खेती करने वाले) भी राज्य सरकार की नीति के अनुसार KCC के पात्र हो सकते हैं।"
              },
              {
                question: "फसल बीमा का दावा कैसे करें?",
                answer: "फसल क्षति होने पर तुरंत ये कदम उठाएं:\n\n1. ग्राम पंचायत/रेवेन्यू अधिकारी को सूचित करें\n2. क्षति की तस्वीरें लें (मोबाइल से)\n3. बीमा कंपनी के स्थानीय अधिकारी को सूचित करें\n4. दावा फॉर्म भरकर जरूरी दस्तावेज संलग्न करें\n5. कंपनी अधिकारी खेत का निरीक्षण करेगा\n6. मुआवजा राशि बैंक खाते में भेजी जाएगी\n\nदावा प्रक्रिया में 45-60 दिन लग सकते हैं।"
              },
              {
                question: "मृदा स्वास्थ्य कार्ड में क्या जानकारी होती है?",
                answer: "मृदा स्वास्थ्य कार्ड में ये जानकारी होती है:\n\n• मिट्टी का प्रकार (काली, लाल, दोमट आदि)\n• मुख्य पोषक तत्वों (नाइट्रोजन, फॉस्फोरस, पोटाश) की स्थिति\n• सूक्ष्म पोषक तत्वों (जिंक, आयरन, मैंगनीज आदि) का स्तर\n• मिट्टी का pH मान (अम्लीय/क्षारीय स्तर)\n• विशिष्ट फसलों के लिए उर्वरक सिफारिशें\n• जैविक कार्बन की मात्रा\n\nइस कार्ड के आधार पर आप सही मात्रा में सही खाद डाल सकते हैं।"
              },
              {
                question: "क्या एक परिवार के एक से अधिक सदस्य योजनाओं का लाभ ले सकते हैं?",
                answer: "PM-KISAN जैसी योजनाओं में एक परिवार के सिर्फ एक सदस्य को ही लाभ मिल सकता है, भले ही परिवार के पास अलग-अलग नामों पर एक से अधिक जमीन हो।\n\nहालांकि, KCC और फसल बीमा जैसी योजनाओं में संयुक्त जमीन धारक या अलग-अलग जमीन वाले परिवार के सदस्य भी लाभ ले सकते हैं, बशर्ते वे सभी पात्रता शर्तों को पूरा करते हों।"
              },
              {
                question: "आवेदन की स्थिति कैसे चेक करें?",
                answer: "आवेदन की स्थिति चेक करने के तरीके:\n\n1. PM-KISAN के लिए: pmkisan.gov.in पर 'Beneficiary Status' में आधार नंबर/मोबाइल नंबर डालें\n2. KCC के लिए: संबंधित बैंक शाखा में संपर्क करें\n3. फसल बीमा के लिए: pmfby.gov.in पर Claim Status चेक करें\n4. किसान सुविधा ऐप से भी सभी योजनाओं की स्थिति देख सकते हैं\n\nअगर 2 महीने से ज्यादा समय हो गया है और स्थिति नहीं अपडेट हुई है, तो जिला कृषि अधिकारी से संपर्क करें।"
              }
            ].map((item, index) => (
              <div key={index} className="border-b border-gray-200 pb-4 last:border-0">
                <button 
                  onClick={() => toggleFaq(index)}
                  className="flex justify-between items-center w-full text-left font-semibold text-lg text-gray-800 hover:text-blue-600 focus:outline-none"
                >
                  <span>{item.question}</span>
                  <svg 
                    className={`w-5 h-5 text-gray-500 transform transition-transform duration-300 ${activeFaq === index ? 'rotate-180' : ''}`}
                    fill="none" 
                    viewBox="0 0 24 24" 
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {activeFaq === index && (
                  <div className="mt-3 text-gray-600 whitespace-pre-line bg-gray-50 p-4 rounded-lg">
                    {item.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>

        {/* SEO Optimized Content */}
        <section className="mb-12 bg-white rounded-xl shadow-md p-6">
          <h2 className="text-3xl font-bold mb-6 text-center text-gray-800">
            किसान योजनाओं के बारे में पूरी जानकारी
          </h2>
          <div className="prose max-w-none">
            <h3 className="text-xl font-semibold text-gray-800">किसानों के लिए सरकारी योजनाओं का महत्व</h3>
            <p className="text-gray-700">
              भारत सरकार ने किसानों की आय बढ़ाने और कृषि क्षेत्र को मजबूत बनाने के लिए कई महत्वपूर्ण योजनाएं शुरू की हैं। इन योजनाओं से किसानों को वित्तीय सहायता, फसल सुरक्षा और आधुनिक कृषि तकनीकों तक पहुंच मिलती है। PM-KISAN, KCC, फसल बीमा और मृदा स्वास्थ्य कार्ड जैसी योजनाएं किसानों के लिए वरदान साबित हो रही हैं।
            </p>
            
            <h3 className="text-xl font-semibold text-gray-800 mt-6">PM-KISAN योजना के मुख्य लाभ</h3>
            <p className="text-gray-700">
              प्रधानमंत्री किसान सम्मान निधि (PM-KISAN) योजना के तहत किसानों को सालाना 6000 रुपये की वित्तीय सहायता दी जाती है। यह राशि तीन समान किस्तों में सीधे किसानों के बैंक खातों में ट्रांसफर की जाती है। इस योजना का मुख्य उद्देश्य छोटे और सीमांत किसानों को खेती के लिए आर्थिक सहायता प्रदान करना है। योजना का लाभ लेने के लिए किसानों के पास अपनी खेती की जमीन होना आवश्यक है।
            </p>
            
            <h3 className="text-xl font-semibold text-gray-800 mt-6">किसान क्रेडिट कार्ड (KCC) के फायदे</h3>
            <p className="text-gray-700">
              किसान क्रेडिट कार्ड (KCC) किसानों को कम ब्याज दर पर ऋण सुविधा प्रदान करता है। इसके तहत किसानों को 3 लाख रुपये तक का ऋण मिल सकता है। KCC की विशेषता यह है कि इसमें फसल ऋण के साथ-साथ आकस्मिक जरूरतों के लिए भी अतिरिक्त राशि ली जा सकती है। इस कार्ड से किसानों को फसल बीमा और अन्य सरकारी योजनाओं में भी लाभ मिलता है।
            </p>
            
            <h3 className="text-xl font-semibold text-gray-800 mt-6">फसल बीमा योजना की विशेषताएं</h3>
            <p className="text-gray-700">
              प्रधानमंत्री फसल बीमा योजना (PMFBY) किसानों को प्राकृतिक आपदाओं से सुरक्षा प्रदान करती है। इस योजना के तहत बाढ़, सूखा, ओलावृष्टि या कीटों से फसल को हुए नुकसान पर किसानों को मुआवजा दिया जाता है। योजना का प्रीमियम बहुत कम है और अधिकांश भाग सरकार द्वारा वहन किया जाता है। इससे किसानों को फसल खराब होने की स्थिति में आर्थिक सुरक्षा मिलती है।
            </p>
          </div>
        </section>

        {/* Helpline Section */}
        <section className="bg-blue-700 rounded-xl shadow-lg p-8 text-white">
          <h2 className="text-3xl font-bold mb-6 text-center">अधिक जानकारी के लिए संपर्क करें</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-blue-800 p-5 rounded-lg">
              <div className="flex items-center mb-3">
                <svg className="w-8 h-8 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <h3 className="text-xl font-semibold">किसान कॉल सेंटर</h3>
              </div>
              <p className="mb-2">टोल फ्री नंबर: <span className="font-bold">1800-180-1551</span></p>
              <p>समय: सुबह 6 बजे से रात 10 बजे तक (सोमवार से शनिवार)</p>
            </div>
            
            <div className="bg-blue-800 p-5 rounded-lg">
              <div className="flex items-center mb-3">
                <svg className="w-8 h-8 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <h3 className="text-xl font-semibold">ईमेल सहायता</h3>
              </div>
              <p className="mb-2">ईमेल: <span className="font-bold">kisan.gov.in@gmail.com</span></p>
              <p>वेबसाइट: <a href="https://agriculture.gov.in" target="_blank" rel="noopener noreferrer" className="font-bold underline">agriculture.gov.in</a></p>
            </div>
            
            <div className="bg-blue-800 p-5 rounded-lg">
              <div className="flex items-center mb-3">
                <svg className="w-8 h-8 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
                <h3 className="text-xl font-semibold">मोबाइल सेवाएं</h3>
              </div>
              <p className="mb-2">WhatsApp हेल्पडेस्क: <span className="font-bold">+91 9599664433</span></p>
              <p>Kisan Suvidha App: <span className="font-bold">9013151515</span> पर मिस्ड कॉल दें</p>
            </div>
          </div>
          
          <div className="mt-8 bg-blue-900 p-4 rounded-lg">
            <h3 className="text-xl font-semibold mb-3 text-center">राज्यवार हेल्पलाइन नंबर</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
              <div><span className="font-medium">उत्तर प्रदेश:</span> 0522-2720550</div>
              <div><span className="font-medium">महाराष्ट्र:</span> 022-22025291</div>
              <div><span className="font-medium">पंजाब:</span> 0172-2702951</div>
              <div><span className="font-medium">राजस्थान:</span> 0141-2227265</div>
              <div><span className="font-medium">मध्य प्रदेश:</span> 0755-2551306</div>
              <div><span className="font-medium">बिहार:</span> 0612-2206209</div>
              <div><span className="font-medium">पश्चिम बंगाल:</span> 033-23508386</div>
              <div><span className="font-medium">गुजरात:</span> 079-23259333</div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default GovernmentSchemes;